/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {JournalLog} from './JournalLog';
import {JournalLogFromJSON, JournalLogFromJSONTyped, JournalLogToJSON} from './JournalLog';
import type {CalculationStatusEnum} from './CalculationStatusEnum';
import {
  CalculationStatusEnumFromJSON,
  CalculationStatusEnumFromJSONTyped,
  CalculationStatusEnumToJSON
} from './CalculationStatusEnum';

/**
 *
 * @export
 * @interface JournalTaskRunPoint
 */
export interface JournalTaskRunPoint {
  /**
   *
   * @type {Date}
   * @memberof JournalTaskRunPoint
   */
  runAt: Date;
  /**
   *
   * @type {number}
   * @memberof JournalTaskRunPoint
   */
  calculationNumber: number;
  /**
   *
   * @type {CalculationStatusEnum}
   * @memberof JournalTaskRunPoint
   */
  status: CalculationStatusEnum;
  /**
   *
   * @type {Array<JournalLog>}
   * @memberof JournalTaskRunPoint
   */
  items: Array<JournalLog>;
  /**
   *
   * @type {boolean}
   * @memberof JournalTaskRunPoint
   */
  readonly isWarning: boolean;
}

/**
 * Check if a given object implements the JournalTaskRunPoint interface.
 */
export function instanceOfJournalTaskRunPoint(value: object): value is JournalTaskRunPoint {
  if (!('runAt' in value) || value['runAt'] === undefined) return false;
  if (!('calculationNumber' in value) || value['calculationNumber'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('items' in value) || value['items'] === undefined) return false;
  if (!('isWarning' in value) || value['isWarning'] === undefined) return false;
  return true;
}

export function JournalTaskRunPointFromJSON(json: any): JournalTaskRunPoint {
  return JournalTaskRunPointFromJSONTyped(json, false);
}

export function JournalTaskRunPointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): JournalTaskRunPoint {
  if (json == null) {
    return json;
  }
  return {
    runAt: new Date(json['run_at']),
    calculationNumber: json['calculation_number'],
    status: CalculationStatusEnumFromJSON(json['status']),
    items: (json['items'] as Array<any>).map(JournalLogFromJSON),
    isWarning: json['is_warning']
  };
}

export function JournalTaskRunPointToJSON(
  value?: Omit<JournalTaskRunPoint, 'is_warning'> | null
): any {
  if (value == null) {
    return value;
  }
  return {
    run_at: value['runAt'].toISOString(),
    calculation_number: value['calculationNumber'],
    status: CalculationStatusEnumToJSON(value['status']),
    items: (value['items'] as Array<any>).map(JournalLogToJSON)
  };
}
